export const selectNameFilter = (state) => state.filters.name;
